<template>
    <div class="ui-accordion-list">
        <div v-if="title" class="ui-accordion-list__title">{{ title }}</div>

        <div class="ui-accordion-list__items">
            <UIAccordionItem
                v-for="(item, index) in items"
                :key="index"
                :title="item.title"
                :content="item.content"
            >
                <template v-if="hasCustomSlot(index)" #content>
                    <slot :name="'content-' + index"></slot>
                </template>
            </UIAccordionItem>
        </div>
    </div>
</template>

<script lang="ts" setup>
    import { getCurrentInstance, defineProps } from 'vue';
    import UIAccordionItem from '@/components/ui/UIAccordionItem/UIAccordionItem.vue';

    defineProps<{
        items: { title: string, content: string }[],
        title?: string,
    }>();

    const instance = getCurrentInstance();
    const slots = instance?.slots;

    function hasCustomSlot(index: number): boolean {
        return slots !== undefined && !!slots[`content-${index}`];
    }
</script>

<style lang="scss" scoped>
    @use './UIAccordionList.scss' as *;
</style>
